import React from 'react'

export default function OldPhone(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width='13'
      height='13'
      viewBox='0 0 13 13'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M3.1375 5.74375C4.0375 7.5125 5.4875 8.95625 7.25625 9.8625L8.63125 8.4875C8.8 8.31875 9.05 8.2625 9.26875 8.3375C9.96875 8.56875 10.725 8.69375 11.5 8.69375C11.8438 8.69375 12.125 8.975 12.125 9.31875V11.5C12.125 11.8438 11.8438 12.125 11.5 12.125C5.63125 12.125 0.875 7.36875 0.875 1.5C0.875 1.15625 1.15625 0.875 1.5 0.875H3.6875C4.03125 0.875 4.3125 1.15625 4.3125 1.5C4.3125 2.28125 4.4375 3.03125 4.66875 3.73125C4.7375 3.95 4.6875 4.19375 4.5125 4.36875L3.1375 5.74375Z'
        fill='currentColor'
      />
    </svg>
  )
}
